import { isAxiosError } from "axios";

const RETRYABLE_CLIENT_STATUSES = new Set([401, 408, 429]);

export function isNonRetryableClientError(err: unknown): boolean {
  if (!isAxiosError(err) || !err.response) {
    return false;
  }

  const status = err.response.status;
  return status >= 400 && status < 500 && !RETRYABLE_CLIENT_STATUSES.has(status);
}
